module.exports = __webpack_public_path__ + "img/info_full_gray.f84dcbdc.svg";